// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.PredictedPreview.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Preview component
 */
import React from 'react';
import { observer ,autorun } from 'mobx-react';
import EventsUtils from 'EventUtils';
import FormGroup from 'share/components/controls/Izenda.FormGroup';
import Label from 'share/components/controls/Izenda.Label';
import DropDown from 'share/components/controls/Izenda.DropDown';
import Input from 'share/components/controls/Izenda.Input';
import constants from 'logic/data/Izenda.CalculatedFieldConstants';
import ReportPartUtils from 'share/utils/Izenda.ReportPartUtils';
import localizer from 'share/localization/Izenda.Localizer';

@observer
class Preview extends React.Component {
  static displayName = 'Preview';

  /**
   * Handle preview action.
   */
  preview = () => {
    let {
      store,
      validation: valManager,
      reportDesigner,
      reportPart,
      type,
      querySourceId,
      startLoading,
      endLoading,
      updateError
    } = this.props;

    valManager.reset();

    switch (type.name) {
      case constants.TYPES.SUB_TOTAL.name:
      case constants.TYPES.GRAND_TOTAL.name:
        startLoading();
        return store
          .previewReportProperties(reportDesigner, reportPart)
          .then(errors => updateError(errors))
          .finally(endLoading);
      default:
        startLoading();
        return store.preview.bind(store)(querySourceId)
          .then(errors => updateError(errors))
          .finally(endLoading);
    }
  }

  render() {
    let notifyChange = EventsUtils.notifyChange;
    let { localization, store: { clonedModel: model }, type } = this.props;
    const  prediction  = localizer.getText('PREDICTED_PREDICTION');
    const classify =   localizer.getText('PREDICTED_CLASSIFICATION');

    // const previewResult = ReportPartUtils.applyFormater(
    //   model.izendaDataType,
    //   model.format.format,
    //   model.previewResult
    // );

      
        if(this.props.store.clonedModel.selectedModelType && this.props.store.clonedModel.selectedModelType !== undefined){
          if(this.props.store.clonedModel.selectedModelType === 'predict'){
             this.modelType = prediction;
           }
           else if(this.props.store.clonedModel.selectedModelType === 'classify'){
            this.modelType = classify;
           }
           else{

            //this.modelType = ''
           }
          
        }

    return (   
      <FormGroup className="addPredictedModelDetails">  
     <div className="" >
        <h4>Model Details</h4>
        <table  height="300">
              <tbody>
                <tr>
                  <th >Target Field</th>
                  <td ><span id="targetField">
                  {this.props.store.clonedModel.targetValue}
                  </span><br/></td>
                </tr>
                <tr>
                  <th>Model Type</th>
                  <td><span id="Model">
                   { this.modelType }                
                  </span></td>
                </tr>
                <tr>
                  <th>
                   { (this.props.store.clonedModel.selectedModelType=== 'predict') ? 
                      'Percentage Error' : 'Model Accuracy'
                   } 
                  </th>
                  <td><span id="accuracy">
                  {
                   (this.props.store.clonedModel.selectedModelType=== 'predict' ) ?
                    (this.props.store.clonedModel.percentError) ?

                    ( parseFloat(this.props.store.clonedModel.percentError).toFixed(2)  + '%' ) : null 

                    :  (this.props.store.clonedModel.accuracy) ?
                    ( 100 * this.props.store.clonedModel.accuracy + '%' ) : null 
                  }
                  </span></td>
              </tr>              
              <tr className="inputFeaturesWrap">
                  <th >Input Features</th>
                  <td >
                    <div >
                      <ul>
                        {   
                          (this.props.store.clonedModel.inputFeatures) ?  
                              this.props.store.clonedModel.inputFeatures.map( feature =>{
                                return <li key={feature}>{feature}</li>
                              }) : null  
                          }

                      </ul>
                    </div>
                  </td>
                </tr>
            </tbody>    
          </table>
        </div> 
      </FormGroup>
    );
  }
}

export default Preview;



// WEBPACK FOOTER //
// ./ui/share/components/controls/predictedField/Izenda.PredictedPreview.js